import {Component, Input} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {UserService} from "../../../common/user.service";

@Component({
    selector: 'ssd-sessions-data',
    templateUrl: './ssd-session-data.component.html',
    styleUrls: ['../shop-session-dashboard-tab.scss'],
    standalone: false
})
export class SsdSessionDataComponent extends BaseComponent {

    @Input() shopSessions: any;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
    ) {
        super(userService, loggerService);
    }

}
